/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2DesktopChat/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2DesktopChat({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2DesktopChat",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 13,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2DesktopChat.Svg"
  data-view-path={viewPath}
 viewBox="0 0 13 12"
 style={{'--as-1-Z2qwUuY': alignSelf,'--mt-2-Z2qwUuY': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2qwUuY': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2qwUuY': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2qwUuY': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2qwUuY': opacity,'--w-10-Z2qwUuY': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2qwUuY': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2qwUuY': fill,'--a-7-Z2qwUuY': isAnimated ? animation : "none",'--sd-8-Z2qwUuY': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2qwUuY': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2DesktopChat.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.153 3.984c0 .473.384.857.857.857h1.898v1.036c0 .342.382.546.666.356l2.09-1.392h.979a.857.857 0 00.857-.857V.857A.857.857 0 0011.643 0H6.01a.857.857 0 00-.857.857v3.127zM7.8 9.429h3.415c.71 0 1.286-.576 1.286-1.286V6.857a.857.857 0 10-1.714 0v.857H2.214V2.571h.857a.857.857 0 000-1.714H1.786C1.076.857.5 1.433.5 2.143v6c0 .71.576 1.286 1.286 1.286H5.2l-.46 1.285H3.93a.643.643 0 100 1.286H9.07a.643.643 0 000-1.286H8.26l-.46-1.285z"
 style={{'--f-12-Z2qwUuY': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}